export default "__VITE_ASSET__BBiA3U$h__"